import { render, staticRenderFns } from "./reportePtiRevisionV2.vue?vue&type=template&id=a2fa4cf8&scoped=true"
import script from "./reportePtiRevisionV2.vue?vue&type=script&lang=js"
export * from "./reportePtiRevisionV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fa4cf8",
  null
  
)

export default component.exports